<template>
  <div>
    <button class="btn btn-sm btn-xs btn-success mr-2 font-weight-bolder"
            data-toggle="modal"
            data-target="#add-vessel-management"
            v-if="(isSystemAdmin || isPrincipal || isPrincipalStaff || isDesignatedPrincipal) && !isKline"
    >
      <span class="fas fa-user"></span>
      Add Management History Record
    </button>

    <!--        <p>{{latestRecord}}</p>-->

    <cms-modal unique="add-vessel-management" title="Add Management History" size="lg">

      <form @submit.prevent="confirmAddVesselManagement">
        <div class="form-group form-row mb-1" :class="{'has-error': newVesselManagementErrors.management_from_id}">
          <label for="management-from" class="col col-sm-3 col-form-label font-weight-bolder">
            From:
          </label>
          <div class="col col-sm-8 offset-1 col-form-label p-0">
            <!--            <span class="help-block text-success" v-if="latestRecord.management_from_id">-->
            <!--                    </span>-->

            <select id="management-from" class="form-control form-control-xs"
                    v-model="newVesselManagement.management_from_id"
                    @change="showOtherFrom"
            >
              <option :value="undefined">--- Select Management ---</option>
              <option v-for="management in managements" :key="management.id" :value="management.id">
                {{ management.name }}
              </option>
              <option value="">--- Other ---</option>
            </select>
            <span class="help-block" v-if="newVesselManagementErrors.management_from_id !== ''">
                      <small><strong>{{ newVesselManagementErrors.management_from_id }}</strong></small>
                    </span>
          </div>
        </div>

        <div class="form-group form-row mb-1"
             :class="{'has-error': newVesselManagementErrors.other_management_from}"
             v-if="otherFrom">
          <label for="other-management-from" class="col col-sm-3 col-form-label font-weight-bolder">
            Other:
          </label>

          <div class="col col-sm-8 offset-1 col-form-label p-0">
            <input type="text" id="other-management-from"
                   class="form-control form-control-xs"
                   placeholder="Specify Management Name for this record"
                   v-model="newVesselManagement.other_management_from"
            >
            <span class="help-block" v-if="newVesselManagementErrors.other_management_from !== ''">
                      <small><strong>{{ newVesselManagementErrors.other_management_from }}</strong></small>
                    </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newVesselManagementErrors.management_to_id}">
          <label for="management-to" class="col col-sm-3 col-form-label font-weight-bolder">
            To:
          </label>
          <div class="col col-sm-8 offset-1 col-form-label p-0">

            <select id="management-to" class="form-control form-control-xs"
                    v-model="newVesselManagement.management_to_id"
                    @change="showOtherTo"

            >
              <option :value="undefined">--- Select Management ---</option>
              <option v-for="management in managements" :key="management.id" :value="management.id">
                {{ management.name }}
              </option>
              <option value="">--- Other ---</option>
            </select>
            <span class="help-block" v-if="newVesselManagementErrors.management_to_id !== ''">
                      <small><strong>{{ newVesselManagementErrors.management_to_id }}</strong></small>
                    </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newVesselManagementErrors.other_management_to}"
        v-if="otherTo">
          <label for="other-management-to" class="col col-sm-3 col-form-label font-weight-bolder">
            Other:
          </label>
          <div class="col col-sm-8 offset-1 col-form-label p-0">
            <input type="text" id="other-management-to"
                   class="form-control form-control-xs"
                   placeholder="Specify Management Name for this record"
                   v-model="newVesselManagement.other_management_to"
            >
            <span class="help-block" v-if="newVesselManagementErrors.other_management_to !== ''">
                      <small><strong>{{ newVesselManagementErrors.other_management_to }}</strong></small>
                    </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newVesselManagementErrors.date_transferred}">
          <label for="new-date-from" class="col col-sm-3 col-form-label font-weight-bolder">
            Date Transferred:
          </label>
          <div class="col col-sm-8 offset-1 col-form-label p-0">
            <input type="date" id="new-date-from"
                   class="form-control form-control-xs"
                   v-model="newVesselManagement.date_transferred"
            >
            <span class="help-block" v-if="newVesselManagementErrors.date_transferred !== ''">
                      <small><strong>{{ newVesselManagementErrors.date_transferred }}</strong></small>
                    </span>
          </div>
        </div>

        <button type="submit" class="btn btn-warning btn-sm btn-xs mr-3 font-weight-bolder float-right">
          <i class="fas fa-save"></i>
          Save
        </button>

      </form>


    </cms-modal>
  </div>
</template>

<script>
import CmsModal from '@/components/elements/CmsModal';
import {mapActions, mapGetters} from 'vuex';
import {vueAppMixin} from '@/mixins/vueAppMixin';
import {formMixin} from '@/mixins/formMixin';
import {gateMixin} from '@/mixins/gateMixin';

export default {
  name: 'AddManagementHistory',

  mixins: [vueAppMixin, formMixin, gateMixin],

  components: {CmsModal},

  data() {
    return {
      newVesselManagement: {
        management_from_id: undefined,
        other_management_from: undefined,
        management_to_id: undefined,
        other_management_to: undefined,
      },
      newVesselManagementErrors: {},

      otherFrom: false,
      otherTo: false,

    };
  },

  methods: {
    ...mapActions([
      'addVesselManagement',
    ]),

    async confirmAddVesselManagement() {
      if (await this.confirmCreateAlert()) {
        let params = {
          vessel_id: this.$route.params.id,

          management_from_id: this.newVesselManagement.management_from_id,
          other_management_from: this.newVesselManagement.other_management_from,

          management_to_id: this.newVesselManagement.management_to_id,
          other_management_to: this.newVesselManagement.other_management_to,

          date_transferred: this.newVesselManagement.date_transferred,
          management_id: this.newVesselManagement.management_id,
        };
        let newVesselManagement = await this.addVesselManagement(params);
        if (newVesselManagement) {
          if (newVesselManagement.errors) {
            this.newVesselManagementErrors = newVesselManagement.errors;
          } else {
            this.newVesselManagement = {};
            // this.newVesselManagement.other_management_to = this.otherTo = false;
            this.otherFrom = false;
            this.otherTo = false;
            this.successAlert('Vessel Management Record Successfully Added', 'CREATE');
            document.getElementById('close-add-vessel-management').click();
          }
        } else {
          this.errorAlert('Failed to Add Vessel Management Record', 'CREATE');
        }
      }
    },

    // showOtherFrom() {
    //   this.otherFrom = true;
    //   console.log(this.otherFrom, 'other from');
    //   console.log('other from');
    // },

    showOtherFrom: function(e) {
      this.otherFrom = e.target.value === '';
      // console.log(this.otherFrom, 'otherFrom');

      // if (e.target.value === 'otherFrom') {
      //   this.otherFrom = true;
      // }else{
      //   this.otherFrom = false;
      // }
    },

    showOtherTo: function(e) {
      this.otherTo = e.target.value === '';
      // console.log(this.otherTo, 'otherTo');
    },

  },

  computed: {
    ...mapGetters([
      'vesselManagements',
      'managements',
      'vesselInfo',
    ]),

    latestRecord() {
      if (this.vesselManagements.length) return this.vesselManagements[0];
      return {};
    },

  },

  created() {
    //

  },

  destroyed() {
  },

  watch: {
    'newVesselManagement.other_management_from'() {
      if (this.newVesselManagement.other_management_from) {
        this.newVesselManagement.management_from_id = undefined;
      }

    },

    'newVesselManagement.management_from_id'() {
      if (this.newVesselManagement.management_from_id) {
        this.newVesselManagement.other_management_from = null;
      }
    },

    'newVesselManagement.other_management_to'() {
      if (this.newVesselManagement.other_management_to) {
        this.newVesselManagement.management_to_id = undefined;
      }
    },

    'newVesselManagement.management_to_id'() {
      if (this.newVesselManagement.management_to_id) {
        this.newVesselManagement.other_management_to = null;
      }
    },

    'latestRecord.management_to_id'() {
      if (this.latestRecord.management_to_id) {
        this.newVesselManagement.other_management_from = null;
        this.otherFrom = false;
        this.newVesselManagement.management_from_id = this.latestRecord.management_to_id;
      }
    },

    'latestRecord.other_management_to'() {
      if (this.latestRecord.other_management_to) {
        this.newVesselManagement.management_from_id = undefined;
        this.otherFrom = true;
        this.newVesselManagement.other_management_from = this.latestRecord.other_management_to;
      }
    },

  },

};
</script>

<style scoped>

</style>
